export const SIMULCAST_LAYER_NAMES = ['h90', 'h180', 'h216', 'h360', 'h540', 'h720'] as const

export type SimulcastLayerName = (typeof SIMULCAST_LAYER_NAMES)[number]

export interface CaptureProfile {
  resolution: { width: number; height: number; frameRate: number }
  publish: {
    videoEncoding: { maxBitrate: number; maxFramerate: number }
    simulcastLayers: readonly SimulcastLayerName[]
    degradationPreference: 'maintain-framerate'
  }
  segmentationInterval: number
}

export const LIGHT_CAPTURE: CaptureProfile = {
  resolution: { width: 640, height: 360, frameRate: 15 },
  publish: {
    videoEncoding: { maxBitrate: 400_000, maxFramerate: 15 },
    simulcastLayers: ['h180'],
    degradationPreference: 'maintain-framerate',
  },
  segmentationInterval: 2,
}

export interface StepCaptureProfile {
  resolution: { width: number; height: number; frameRate: number }
  publish: CaptureProfile['publish'] | null
  segmentationInterval: number
}

export const NORMAL_CAPTURE: StepCaptureProfile = {
  resolution: { width: 1280, height: 720, frameRate: 30 },
  publish: null,
  segmentationInterval: 1,
}
